/**
 * @module NotificationsConvexComponentConfig
 * @package @geenius/notifications-convex
 * @description Registers the notifications Convex component namespace so
 * consuming applications can mount the package under a stable component
 * identifier.
 */

import { defineComponent } from "convex/server";

const component = defineComponent("notifications");
export default component;
